export function contactUs() {

    const contactToggle = document.querySelectorAll('.contactToggle');
    
    function toggleContact() {
        console.log('Contact Toggle')
        const contactUs = document.getElementById('contact-us');
        contactUs.classList.toggle('show');
    }

}